import * as React from 'react';
import { registerComponent, withProgressiveHydration } from '@avensia/excite';
import { BlockLayout } from 'webapp/components/block-layout';
import {
  Block,
  contentWidthDecorator,
  desktopEdgeMarginDecorator,
  mapContentWidth,
} from 'webapp/components/page-layout';
import { styled } from '@glitz/react';
import { createMaxSmallViewportDecorator } from 'webapp/viewport';
import { useNinetailedClickEvent, useTrackingBlock, NinetailedExperience } from '@avensia/excite-ninetailed';
import { LayoutProvider } from 'webapp/shared/use-layout';

export default registerComponent<NordicNest.Api.LayoutBlock>(React.memo(withProgressiveHydration(LayoutBlock)));

function LayoutBlock(props: NordicNest.Api.LayoutBlock) {
  const ref = React.createRef<HTMLDivElement>();
  useTrackingBlock(ref);

  const ninetailedClick = useNinetailedClickEvent();

  return (
    <LayoutProvider
      contentWidthInPx={mapContentWidth(props.contentWidth)}
      hasLayoutBlockParent
      layout={props.layout}
      gap={props.gap}
      maxContentWidth={props.contentWidth}
      mobileLayout={props.mobileLayout}
    >
      <Block
        id={props.id}
        ref={ref}
        css={styled(
          contentWidthDecorator(props.contentWidth),
          props.marginBottom !== false && marginDecorator,
          props.contentWidth === 'normal' && desktopEdgeMarginDecorator,
        )}
        onClick={ninetailedClick}
      >
        <BlockLayout layout={props.layout} gap={props.gap} mobileLayout={props.mobileLayout}>
          {props.blocks?.items
            .filter(i => i)
            .map((block, i) => <NinetailedExperience index={i} key={block?.id + i} item={block as any} />)}
        </BlockLayout>
      </Block>
    </LayoutProvider>
  );
}

const marginDecorator = styled(createMaxSmallViewportDecorator({ marginBottom: t => t.spacing.m }), {
  marginBottom: t => t.spacing.xl,
});
